export function initLiveSearch() {
    const form = document.querySelector('.navbar-search-wrap[data-live-search]');
    if (!form) return;

    const input = form.querySelector('input[type="text"]');
    if (!input) return;

    const signalUrl = form.dataset.liveSearch;

    const panel = document.createElement('div');
    panel.className = 'live-search-panel';
    panel.setAttribute('aria-live', 'polite');
    form.appendChild(panel);

    const overlay = document.createElement('div');
    overlay.className = 'live-search-overlay';
    document.body.appendChild(overlay);

    let debounceTimer = null;
    let activeIndex = -1;

    function getItems() {
        return panel.querySelectorAll('.live-search-item');
    }

    function setActive(index) {
        const items = getItems();
        items.forEach((el, i) => el.classList.toggle('is-active', i === index));
        activeIndex = index;
    }

    function close() {
        panel.classList.remove('is-open');
        overlay.classList.remove('is-open');
        activeIndex = -1;
    }

    function open() {
        panel.classList.add('is-open');
        overlay.classList.add('is-open');
    }

    async function fetchResults(query) {
        const url = `${signalUrl}&query=${encodeURIComponent(query)}`;
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) return [];
        const data = await res.json();
        return data.results || [];
    }

    function renderResults(results, query) {
        if (results.length === 0) {
            panel.innerHTML = `<div class="live-search-empty">Žádné výsledky pro <strong>${escapeHtml(query)}</strong></div>`;
        } else {
            panel.innerHTML = results.map(item => `
                <a href="/produkt/${escapeHtml(item.slug)}" class="live-search-item">
                    <div class="live-search-item-img">
                        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : '<div class="live-search-item-no-img"></div>'}
                    </div>
                    <div class="live-search-item-info">
                        <span class="live-search-item-title">${escapeHtml(item.title)}</span>
                        ${item.price ? `<span class="live-search-item-price">${item.price} Kč / den</span>` : ''}
                    </div>
                </a>
            `).join('');
        }
        open();
        activeIndex = -1;
    }

    function escapeHtml(str) {
        return String(str).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    }

    input.addEventListener('keyup', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter') return;

        const query = input.value.trim();
        clearTimeout(debounceTimer);

        if (query.length < 1) {
            close();
            return;
        }

        debounceTimer = setTimeout(async () => {
            const results = await fetchResults(query);
            renderResults(results, query);
        }, 200);
    });

    input.addEventListener('keydown', (e) => {
        const items = getItems();
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setActive(Math.min(activeIndex + 1, items.length - 1));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setActive(Math.max(activeIndex - 1, -1));
        } else if (e.key === 'Enter') {
            if (activeIndex >= 0 && items[activeIndex]) {
                e.preventDefault();
                items[activeIndex].click();
            }
            // else: nativní submit formuláře = přechod na stránku s výsledky
        } else if (e.key === 'Escape') {
            close();
            input.blur();
        }
    });

    overlay.addEventListener('click', close);

    document.addEventListener('click', (e) => {
        if (!form.contains(e.target)) close();
    });
}
